import React from 'react'
import { AppAuthContext } from '../constants/index'

const useAppAuth = () => React.useContext(AppAuthContext)
export default useAppAuth
